import { render, staticRenderFns } from "./SettingsBranches.vue?vue&type=template&id=6e78512a&scoped=true"
import script from "./SettingsBranches.vue?vue&type=script&lang=js"
export * from "./SettingsBranches.vue?vue&type=script&lang=js"
import style0 from "./SettingsBranches.vue?vue&type=style&index=0&id=6e78512a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e78512a",
  null
  
)

export default component.exports